import baseTheme from './base';
import mergeWith from 'lodash/mergeWith';
import { cloneDeep } from 'lodash';

export default function createTheme(overrides) {
  const base = cloneDeep(baseTheme);
  return mergeWith(base, overrides, (objValue, srcValue) => {
    if (Array.isArray(objValue)) {
      return srcValue;
    }
  });
}
